
import manageDomain from './manage-domain'

// @note Route paths should not end with a '/'
// '/' endings will be removed and redirected

export default [
    ['/login', require('./admin')],
    ['/', require('./admin')],
    ['/securityGroups', require('./securityGroups')],
    ['/contentGroups', require('./contentGroups')],
    ['/admin', require('./admin')],
    ['/account', require('./account')],
    ['/pageNotFound', require('./pageNotFound')],
    ['/unauthorized', require('./unauthorized')],
    ['/agenda', require('./agenda')],
    ['/logout', require('./logout')],

    ['/events', require('./events/')],
    ['/events/', require('./events/')],
    ['/events/slim', require('./events/')],
    ['/events/grid', require('./events/')],
    ['/events/table', require('./events/')],
    ['/events/calendar', require('./events/')],
    ['/events/expanded', require('./events/')],
    ['/events/create', require('./create-event')],
    ['/editor', require('./editor')],// has query of eventID

    ['/status', require('./system-status')],
    ['/release-notes', require('./release-notes/')],

    ['/help', require('./help-route')],

    ['/manage', require('./manage')],
    ['/manage/ads', require('./vast/index')],
    ['/manage/ads/edit', require('./vast/edit')],// has query
    ['/manage/ads/analytics', require('./vast/analytics')],// has query

    ['/manage/ott', require('./ott/index')],
    ['/manage/ott/edit', require('./ott/edit')],// has query
    ['/manage/ott/roku', require('./ott/roku')],// has query
    ['/manage/vocab', require('../vocab')],

    ['/manage/technicians/schedule', require('./tech-schedule')],

    ['/manage/listing/edit',
        require('../embed/listing/editor/EditorRouteInterface')],

    ['/manage/player/edit',
        require('../embed/player/components/editor/EditorRouteInterface')],

    ['/manage/media', require('./media')],
    ['/manage/encoders', (api, socket, opts, match) => manageDomain(api, socket, opts, {...match, params: {domain: 'encoders'}})],
    ['/manage/categories', (api, socket, opts, match) => manageDomain(api, socket, opts, {...match, params: {domain: 'categories'}})],
    ['/manage/keywords', (api, socket, opts, match) => manageDomain(api, socket, opts, {...match, params: {domain: 'keywords'}})],
    ['/manage/locations', (api, socket, opts, match) => manageDomain(api, socket, opts, {...match, params: {domain: 'locations'}})],
    ['/manage/technicians', (api, socket, opts, match) => manageDomain(api, socket, opts, {...match, params: {domain: 'technicians'}})],
    ['/manage/listing', (api, socket, opts, match) => manageDomain(api, socket, opts, {...match, params: {domain: 'listing'}})],
    ['/manage/player', (api, socket, opts, match) => manageDomain(api, socket, opts, {...match, params: {domain: 'player'}})],
    ['/sourceMultiViewer', require('./sourceMultiViewer')],

    // ['/manage/:domain', require('./manage-domain')],

    ['/import', require('./import')],
    ['/analytics', require('./analytics')] //has eventID query param
];
